module.exports = __webpack_public_path__ + "static/media/logo-atlassian.0e4d3a67.svg";